<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let logs = [];
  let loading = true;
  let error = null;

  let currentPage = 1;
  let pageSize = 20; // По умолчанию на бэке 20
  let totalLogs = 0;
  let filterUserId = "";

  onMount(() => {
    loadLogs();
  });

  async function loadLogs() {
    loading = true;
    error = null;
    const params = {
      page: currentPage,
      pageSize: pageSize,
      userId: filterUserId || undefined,
    };
    const result = await fetchAdminAPI('/spins-log', 'GET', params, authData);
    if (result.success) {
        logs = result.data.data || [];      // <--- ИЗМЕНЕНИЕ
        totalLogs = result.data.total || 0; // <--- ИЗМЕНЕНИЕ
    } else {
      error = result.message;
      logs = [];
      totalLogs = 0;
    }
    loading = false;
  }

  function handleFilter() {
    currentPage = 1;
    loadLogs();
  }

  function changePage(newPage) {
    currentPage = newPage;
    loadLogs();
  }

  $: totalPages = Math.ceil(totalLogs / pageSize);
</script>

<div class="spin-logs-admin-section">
  <div class="admin-section-header">
    <h2>Логи прокрутов рулетки</h2>
  </div>

  <div class="filters-bar">
    <input type="text" bind:value={filterUserId} placeholder="TG ID пользователя" on:input={handleFilter} on:keypress={(e) => e.key === 'Enter' && handleFilter()}>
    <button class="admin-primary" on:click={handleFilter}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: text-bottom;">
            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
        </svg>
        Фильтровать
    </button>
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка логов...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if logs.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">{filterUserId ? 'Логи по вашему запросу не найдены.' : 'Логов прокрутов пока нет.'}</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID Лога</th>
              <th>TG ID</th>
              <th>Сектор ID</th>
              <th>Сектор (Текст)</th>
              <th>Сектор (Тип)</th>
              <th>Время</th>
            </tr>
          </thead>
          <tbody>
            {#each logs as log (log.ID)}
              <tr>
                <td>{log.ID}</td>
                <td>{log.UserID}</td>
                <td>{log.SectorID}</td>
                <td>{log.Sector?.ValueStr || 'N/A'}</td>
                <td>{log.Sector?.SectorType || 'N/A'}</td>
                <td>{new Date(log.SpunAt).toLocaleString()}</td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
      {#if totalLogs > 0}
      <div class="pagination">
        <span class="page-info">Показано {logs.length} из {totalLogs} логов</span>
        <div class="page-controls">
          <button class="admin-action-button" on:click={() => changePage(currentPage - 1)} disabled={currentPage <= 1}>Назад</button>
          <span>Стр. {currentPage} из {totalPages}</span>
          <button class="admin-action-button" on:click={() => changePage(currentPage + 1)} disabled={currentPage >= totalPages}>Вперед</button>
          <select bind:value={pageSize} on:change={() => { currentPage = 1; loadLogs(); }} aria-label="Записей на странице">
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      {/if}
    {/if}
  </div>
</div>

<style>
  .table-responsive-wrapper { overflow-x: auto; }
</style>